import axios from '../../../../utils/request';

function GET_EMAIL() {
    return axios.get("/detect/APushEmail/edit" )
}
function SET_EMAIL(params) {
    return  axios.post("/detect/APushEmail/editPost", {email:params}  )
}

export default {
    GET_EMAIL,
    SET_EMAIL
};